import {Component, Injectable, OnInit, ViewChild} from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import {Observable} from 'rxjs/Observable';
import {ApiService} from '../../../../../core/service/api.service';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';
import { AuxiliarService} from '../../../../../shared/services/auxiliar.service';
import * as moment from 'moment';
import {Angular2Csv} from 'angular2-csv';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import * as _ from 'underscore';
import {AlertaService} from '../../../../../shared/services/alerta.service';


@Injectable()
export class ExternalCallbackLeadService {

    constructor(private api: ApiService) { }

    getInfoLeads(pk,range=null): Observable<any> {
        if(!range){
            let url=this.api.createUrlWithRoute('vna/external-callback-leads',pk);
            return this.api.get(url);
        }
        let url=this.api.createUrlWithRoute('vna/external-callback-leads',pk);
        return this.api.get(url,range);
        }
}

@Component({
  selector: 'app-ext-callback-leads-view-modal',
  templateUrl: './ext-callback-leads-view-modal.component.html',
  styleUrls: ['./ext-callback-leads-view-modal.component.scss'],
    providers:[ExternalCallbackLeadService]

})
export class ExtCallbackLeadsViewModalComponent extends ModalExtended implements OnInit{

  data:any;
  rows: Array<Object>=[];
  enabled:boolean;
  formSearch:FormGroup;
  startAt: number = 0;
  endAt: number = 0;
  perPage: number = 6;
  fromHr:any;
  toHr:any;

  @ViewChild (PaginationComponent) pagination: PaginationComponent;

  constructor(private extHandler: ExternalCallbackLeadService,
              private  aux: AuxiliarService,
              private datesParser: DatesParserService,
              private alerta:AlertaService) {
      super();
      let from= new Date();
      from.setHours(0,0,0,0);
      this.fromHr=from;
      let to= new Date();
      to.setHours(23,59,59,0);
      this.toHr=to;
      this.formSearch=new FormGroup(
        {
            'start':new FormControl('',Validators.required),
            'end':new FormControl('',Validators.required)
        }
    )
  }

  onExit(data) {
        this.applyCallback(data);
        this.close();
  }

  ngOnInit() {
      this.enabled=true;
       this.extHandler.getInfoLeads(this.data.pk)
           .subscribe(result=>{
               this.rows=result;
               this.endAt = (!this.haveToPaginate()) ? this.rows.length : this.perPage;
               this.enabled=false;
               })
  }

  haveToPaginate(): boolean {
        return this.perPage < this.rows.length;
  }

  goToPage(n: number) {
      this.startAt = this.pagination.getStart();
        this.endAt = this.pagination.getEnd();
  }

  copy(url){
     this.aux.copyToClip(url)
  }

  toCsv(): void {
        new Angular2Csv(this.rows, 'external_callback_lead' + moment().unix(), {
            'showLabels' : true,
            'headers':['pk','vna_request_log_pk','url_sent','response_text','response_code','queued_at','sent_at','status','log_response','log_element']
        });
  }

  searchDate(form){
      if(form.valid){
          let rango=this.datesParser.cleanDates(this.formSearch.value, ['start', 'end'], false);
          if(rango['end'] < rango['start']){
              this.alerta.addAlert('warning','Invalid Date Range!!');
              return;
          }
          this.enabled = true;
          this.extHandler.getInfoLeads(this.data.pk,rango)
              .subscribe(result=>{
                  this.rows=result;
                  this.endAt = (!this.haveToPaginate()) ? this.rows.length : this.perPage;
                  this.enabled=false;
              })
      }
  }

}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/modals/ext-callback-leads-view-modal/ext-callback-leads-view-modal.component.ts